import $ from 'jquery';
import { addToBagWithData } from 'modules/add-to-bag';

var trackDonde = function () {
  if (typeof trackAddToCartVisualNav === 'function'){
    trackAddToCartVisualNav();
  }
};


var logEngagement = function () {
    var fromSearch = window.location.search.indexOf("sr=true") > 0; // Inserted in SearchController
    var module = fromSearch
        ? "mobile_search"
        : "mobile_pdp";
    $.ajax({
        type: 'POST',
        data: $.param({
            url: window.location.href,
            module: module,
            action: "add_to_cart"
        }),
        url: '/r/ajax/LogEngagement.jsp'
    });
};
var proceed = function (code, size, showJustAdded) {
    if (showJustAdded) {
        if ($("#notification_wrap_mpdp").length) {
            var data = $.param({
                code : code,
                size: size,
            });
            $.get("/r/mobile/myrevolve/ajax/AddToBagPopup.jsp", data, function(markup){
                $("#notification_wrap_mpdp").html(markup);
                $.modal({
                    open: "product-added-confirmation",
                    triggerOpen: true,
                    triggerElement: '#add-to-bag-btn',
                    onOpen: function() {
                        if (rcProps.abtests.personalizedPla) {
                            window.stickyATB?.block();
                        }
                    },
                    onClose: function() {
                        if (rcProps.abtests.personalizedPla) {
                            window.stickyATB?.unblock();
                        }
                    }
                });
                $("#product-added-confirmation").find('.js-horizontal-scroll').horizontalScroll();
            });
        } else if ($("#product-added-confirmation").length) {
            $.modal({
                open: "product-added-confirmation",
                triggerOpen: true
            });
        } else {
            const param = $.param({
                code : code,
                d : window.rcProps.department,
            });
            $.modal({
                url: "/r/mobile/dialog/AddToBagPopup.jsp",
                type: window.rcProps.addToBagModalType || null,
                data: param,
                triggerOpen: true,
                onComplete: () => {
                    $("#add-to-bag-popup-dialog").find(".view-bag-btn").click(function (e) {
                        window.location = "/r/mobile/ShoppingBag.jsp";
                    });
                    $("#add-to-bag-popup-dialog").find(".continue-shopping-btn").click(function (e) {
                        $.modal.close();
                    });
                }
            });
        }
    }

    $.ajax({
        type: "POST",
        url: "/r/mobile/AjaxUserShoppingBag.jsp",
        success: function (response) {
            var responseObj = eval('(' + response + ')');
            $("#shopping_bag_count").html(responseObj);
        }
    });
};

function getSubscriptionInterval() {
    let subscriptionInterval = 0;
    const $subscriptionSelect = $('#subscription-freq-select');
    if ($subscriptionSelect.is(':visible')){
        subscriptionInterval = $subscriptionSelect.find('option:selected').val();
    }
    return subscriptionInterval;
}


export function addToBag(productcode, size, optCallback, data = {}) {
    var pdpData = window.rcProps.pdp || {};
    var $fittingRoomSize = $('#fittingRoomSize');
    var $fittingRoomMobile = $('#fittingRoomMobile');
    var fittingRoomSizeVal = $fittingRoomSize.length>0?$fittingRoomSize.find(":selected").val():'';
    if (fittingRoomSizeVal && fittingRoomSizeVal.trim().length) {
        if($fittingRoomMobile.length) {
            $fittingRoomMobile.hide();
        }
        $fittingRoomSize.val('');
    }
    const $assignedDefectItemSerialNumber = $('#assignedSellableDefectItemSerialNumber');
    const defectItemSerialNumber = $assignedDefectItemSerialNumber.length ? $assignedDefectItemSerialNumber.val() : '';

    try {
        insertFacebookAddToCart(null, productcode, pdpData.retailPrice, size);
    } catch (e) {
        console.log(e);
    }

    addToBagWithData({
            colorSelect: productcode,
            sizeSelect: size,
            subscriptionInterval: getSubscriptionInterval(),
            fitItemSizes: fittingRoomSizeVal,
            count: 1,
            serialNumber: defectItemSerialNumber
        },
        {
            success: () => {
                $.when(insertPageTrackForMobileWithData({
                        addToCartFlag: true,
                        isSubscription: getSubscriptionInterval() > 0,
                        productCode: productcode,
                    }),
                    logEngagement(),
                    trackDonde()
                ).done(() => {
                    proceed(productcode, size, $.isEmptyObject(data) || data.showJustAdded);
                });
                // add inventory disclaimer to ITEMS ADDED TO BAG popup
                $('#inventory-disclaimer-bag').html($("select#size").data("inventoryDisclaimer"));
            },
            done: (obj) => {
                // start GA add to cart
                var gaProduct = {};
                gaProduct.code = '' + productcode + '';
                gaProduct.name = pdpData.productName;
                gaProduct.category = pdpData.categoryName;
                gaProduct.brand = pdpData.brandName;
                gaProduct.variant = size;
                gaProduct.price = pdpData.price;
                gaProduct.quantity = 1;
                gaAddToCartActionProduct('add', gaProduct);
                // end GA add to cart

                if (typeof addToCartPinterest === 'function') {
                    addToCartPinterest(productcode, pdpData.price, 1);
                }

                if (typeof addToCartReddit === 'function') {
                    var cartItems = new Array();
                    {
                        var cartItem = {};
                        cartItem.productCode = productcode;
                        cartItem.productName = pdpData.productName;
                        cartItem.productCategory = pdpData.categoryName;

                        cartItems.push(cartItem);
                    }
                    addToCartReddit(cartItems, pdpData.price, pdpData.id, pdpData.name, pdpData.categoryName);
                }
                if(typeof spanglePixelAddToCart === 'function'){
                    spanglePixelAddToCart(productcode, pdpData.price,1);
                }

                $("#product-data-container .price__sale, #product-data-container .price__retail").html(obj.msg5);
                if (obj.msg6 !== "hideOriginalPrice") {
                    $("#addToBagSalePriceDiv").removeClass("u-hide");
                    $("#addToBagStandardPriceDiv").addClass("u-hide");
                    $("#product-data-container .price__retail").html(obj.msg6);
                } else {
                    $("#addToBagSalePriceDiv").addClass("u-hide");
                    $("#addToBagStandardPriceDiv").removeClass("u-hide");
                }
                if(obj.msg26){
                    $('#threshhold-add-to-bag').replaceWith(obj.msg26);
                }
                if(obj.msg9 !== ""){
                    $("#preOrderMessage").html(obj.msg9).removeClass("u-hide");
                    if(obj.msg27) {
                        $("#preOrderMessage").removeClass("notification__description");
                    } else {
                        $("#preOrderMessage").addClass("notification__description");
                    }
                } else {
                    $("#preOrderMessage").addClass("u-hide");
                }

                if (typeof brazeAddToCart === 'function') {

                    var canonicalLink = document.querySelector('link[rel="canonical"]');
                    var pdpUrl = canonicalLink ? canonicalLink.href : null;

                    var itemInformation = {
                        code: productcode,
                        name: obj.msg31,
                        src: obj.msg2,
                        srcset: obj.msg26,
                        designer: obj.msg3,
                        designerHref: obj.msg4,
                        price: obj.msg5,
                        origPrice: obj.msg6,
                        disclaimer: obj.msg9,
                        invAlert: obj.msg12,
                        color: obj.msg10,
                        cartTotal: obj.msg11,
                        cartSize: obj.msg13,
                        addlItemsText: obj.msg14,
                        categoryName: obj.msg16,
                        cartItemsCount: obj.msg22,
                        size: obj.msg23,
                        itemQtyInCart: obj.msg24,
                        isPreOrder: obj.msg27,
                        currency: obj.msg28,
                        department: obj.msg29,
                        cat1: obj.msg30,

                    };

                    brazeAddToCart('add',
                        itemInformation.code,
                        itemInformation.name,
                        itemInformation.size,
                        itemInformation.src,
                        pdpUrl,
                        itemInformation.price,
                        itemInformation.currency,
                        itemInformation.department,
                        itemInformation.color,
                        itemInformation.brandName,
                        itemInformation.categoryName,
                        itemInformation.cat1
                    );
                }


                if (typeof optCallback == 'function') {
                    optCallback();
                }
            }
        }
    );
}

export function addBuyNowProduct(code, size, fittingRoomSize, buyNowButton) {
    const rcProps = window.rcProps || {};
    const forceBuyNowExpress = window.location.search.indexOf('forceBNE') >= 0;
    let paymentMethod = (buyNowButton) ? $(buyNowButton).data('bnPaymentMethod') : '';
    $.ajax({
        type: 'POST',
        url: `/r/ajax/BuyNow.jsp?itemsrc=pdp${forceBuyNowExpress ? '&forceBNE=true' : ''}`,
        data: $.param({
            bnCode: code,
            bnSize: size,
            bnPaymentMethod: paymentMethod,
            subscriptionInterval: getSubscriptionInterval(),
            d: rcProps.department,
            sectionUrl: rcProps.sectionUrl,
            fittingRoomSize: fittingRoomSize
        }),
        success: function(obj){
            var rtn = $.parseJSON(obj);
            //trigger fo optimzely
            $(document).trigger('productBuyNow');
            if (rtn && rtn.success) {
                if (rtn.refreshPage) {
                    const searchParams = new URLSearchParams(window.location.search);
                    const addParameter = (searchParams && searchParams.has('bnRefresh')) || window.location.search.indexOf('bnRefresh') < 0;
                    window.location.href = window.location.href + (addParameter ? '&bnRefresh=true' : '');
                    return;
                }
                if (typeof iPinYouBuyNow === 'function'){
                    iPinYouBuyNow(code);
                }
                gaCheckout(1,'SIGNIN');
                const buyNowRedirect = '/r/mobile/LoginCheckout.jsp?bn=true';
                let paymentMethod = (buyNowButton) ? $(buyNowButton).data('bnPaymentMethod') : '';
                const callback = function () {  // Has to be a callback to ensure tracking fires correctly
                    window.location = buyNowRedirect + (!rtn.canPlaceOrder ? '&onAdd=true' : '');
                }
                gaAddToCartActionWithAjax('add',code,size,1);
                $.when(insertPageTrackForMobileWithData({
                        addToCartFlag: true,
                        productCode: code,
                        isBuyNow: true,
                        isApplePay: paymentMethod === 'ApplePay',
                        isSubscription: getSubscriptionInterval() > 0
                    }),
                    logEngagement(),
                    trackDonde()
                ).done(callback);
                if (typeof insertCriteoAddToCart === 'function'){
                    insertCriteoAddToCart(code);
                }
                if (typeof insertRTBHouseAddToCart === 'function') {
                    insertRTBHouseAddToCart(code);
                }
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-to-bag.js